export default __webpack_public_path__ + "static/media/thumb-free.01000a0c.png";